export enum EndpointDirectionEnum {
  Target = 'Target',
  Source = 'Source',
}
